import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Repair({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M11.2601 9.60198L3.64008 17.212C2.77008 18.072 2.77008 19.472 3.63008 20.342H3.62908C4.48908 21.202 5.88908 21.202 6.75908 20.342L14.3691 12.722V12.721C16.9591 13.601 19.7891 12.221 20.6791 9.62099C20.6891 9.58099 20.6991 9.54099 20.7091 9.50099V9.49998C20.9191 8.84998 20.9891 8.16998 20.9291 7.49998C20.8491 6.94998 20.3491 6.56998 19.7991 6.63998C19.5791 6.65998 19.3691 6.76999 19.2191 6.91999L17.4091 8.71999C17.2091 8.90999 16.8891 8.90999 16.6991 8.71999C16.6891 8.70999 16.6891 8.70998 16.6891 8.70998L15.1591 7.17998C14.9591 6.97998 14.9591 6.65999 15.3391 6.27999L16.9491 4.65998C17.3391 4.26998 17.3391 3.63998 16.9591 3.23998C16.7991 3.07998 16.5991 2.97998 16.3791 2.94998C15.6991 2.87998 15.0191 2.94998 14.3791 3.16998V3.15999C11.7491 3.97998 10.2991 6.76999 11.1191 9.38999C11.1291 9.41999 11.1391 9.45998 11.1491 9.49998L11.2601 9.60198Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default Repair;